import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=52685234&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=js"
export * from "./IconTextButton.vue?vue&type=script&lang=js"
import style0 from "./IconTextButton.vue?vue&type=style&index=0&id=52685234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52685234",
  null
  
)

export default component.exports